<app-search-items-grid
    [option]="itemsSelectBoxOption"
    (appFormValue)="addItem($event)"
    [gtinMode]="gtinMode"
    [tabMode]="tabMode"
    [tabs]="tabs"
    [documentType]="documentType"
    [tNVEDCodes]="tNVEDCodes"
    [tNVEDList]="tNVEDList">
</app-search-items-grid>
